import PropTypes from 'prop-types';
import { BillingPlanPropType } from './billing-plan';
import { CouponPropType } from './coupon';
import './currency';

export const PlanInfoPropType = PropTypes.shape({
  plan: BillingPlanPropType,
  billingProviderID: PropTypes.number,
  createDateTimeUTC: PropTypes.string,
  startDateTimeUTC: PropTypes.string,
  endDateTimeUTC: PropTypes.string,
  billingCycleEndDateTimeUTC: PropTypes.string,
  inTrial: PropTypes.bool,
  usage: PropTypes.shape({
    shipments: PropTypes.number,
    users: PropTypes.number,
    channels: PropTypes.number,
    daysElapsed: PropTypes.number,
    daysLeft: PropTypes.number,
  }),
  additionalUsers: PropTypes.shape({
    quantity: PropTypes.number,
    cost: PropTypes.shape({
      value: PropTypes.number,
      code: PropTypes.string,
    }),
  }),
  pendingSubscription: PropTypes.string,
  pendingDateTimeUTC: PropTypes.string,
  cancelledDateTimeUTC: PropTypes.string,
  isLastInvoicePastDueOrFailed: PropTypes.bool,
  planProfileCode: PropTypes.string,
  isPlanLocked: PropTypes.bool,
  isTrialExpired: PropTypes.bool,
  isSubscriptionExpired: PropTypes.bool,
  isCanceled: PropTypes.bool,
  coupons: PropTypes.arrayOf(CouponPropType),
});

/**
 * @typedef {object} PlanInfoPropType
 * @property {BillingInfoPropType} plan
 * @property {number} billingProviderID
 * @property {string} createDateTimeUTC
 * @property {string} startDateTimeUTC
 * @property {string} endDateTimeUTC
 * @property {string} billingCycleEndDateTimeUTC
 * @property {boolean} inTrial
 * @property {object} usage
 * @property {number} usage.shipments
 * @property {number} usage.users
 * @property {number} usage.channels
 * @property {number} usage.daysElapsed
 * @property {number} usage.daysLeft
 * @property {object} additionalUsers
 * @property {number} additionalUsers.quantity
 * @property {CurrencyPropType} additionalUsers.cost
 * @property {string} pendingSubscription
 * @property {string} pendingDateTimeUTC
 * @property {string} cancelledDateTimeUTC
 * @property {boolean} isEndDateAvailable
 * @property {boolean} isLastInvoicePastDueOrFailed
 * @property {string} planProfileCode
 * @property {boolean} isPlanLocked
 * @property {boolean} isTrialExpired
 * @property {boolean} isSubscriptionExpired
 * @property {boolean} isCanceled
 * @property {CouponPropType[]} coupons
 */
